import { Components, Sendum, Services } from '@sendum/core'
import React, { useEffect, useRef, useState } from 'react'
import { Provider } from 'react-redux'
import { Store } from 'redux'

import classes from './index.module.scss'

interface IProps {
    store: Store
    children: JSX.Element
    isSubWidget?: boolean
}

export const Container = (props: IProps): JSX.Element | null => {
    const [isDBInitiated, setDBInitiated] = useState<boolean>(false)
    const [isDCInitiated, setDCInitiated] = useState<boolean>(false)
    const [error, setError] = useState<Error | null>(null)
    const timer = useRef<NodeJS.Timeout>()
    const TIMER_INTERVAL = 100

    const timerHandler = (): void => {
        if (Sendum.isDBInitiated()) {
            setDBInitiated(true)
            if (timer.current) {
                clearInterval(timer.current)
                timer.current = undefined
            }
        }
    }

    const initDeviceConfiguration = async (): Promise<void> => {
        try {
            const config = await Services.API.WidgetsApi.getConfig()
            const isInitiated = Services.DeviceConfigService.DeviceConfig.getInstance().init(config)
            setDCInitiated(isInitiated)
        } catch (ignore) {
            setError(new Error('Widget was not configured completely.'))
            window.parent.postMessage(JSON.stringify({ from: 'WIDGETS', type: 'AUTH_ISSUE' }), '*')
        }
    }

    useEffect(() => {
        if (props.isSubWidget) {
            setDCInitiated(true)
            setDBInitiated(true)
        } else {
            timer.current = setInterval(timerHandler, TIMER_INTERVAL)
            // void initDeviceConfiguration()
        }
    }, [props.isSubWidget])

    useEffect(() => {
        if (props.isSubWidget || !isDBInitiated) {
            return;
        }
        void initDeviceConfiguration();
    }, [isDBInitiated])

    if (error) {
        return null
    }

    return (
        <Provider store={props.store}>
            <Components.CustomToaster />
            <Components.ErrorComponent error={error} />
            {!error &&
                (isDBInitiated && isDCInitiated
                    ? props.children
                    : Sendum.getLoader() || <Components.Loader className={classes.loader} text={'Initializing'} />)}
            <Components.Version />
        </Provider>
    )
}
